import MarkersTableBody from "./MarkersTableBody";

export default MarkersTableBody;
